import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DashboardLayout from './DashboardLayout';
import { fetchWeeklies } from '../../api/api';

const getWeekDates = (weekString) => {
  if (!weekString) return { start: '', end: '' };
  const [year, week] = weekString.split('-W');
  const d = new Date(year, 0, 1 + (week - 1) * 7);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const startDate = new Date(d.setDate(diff));
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 4);

  const formatDate = (date) => date.toLocaleDateString('pt-BR');
  return {
    start: formatDate(startDate),
    end: formatDate(endDate),
  };
};

const WeeklyList = () => {
  const [weeklyList, setWeeklyList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWeeklies = async () => {
      try {
        const data = await fetchWeeklies();
        if (data) {
          const list = data.map((item) => ({
            week: item.week,
            dates: getWeekDates(item.week),
            theme: item.theme || 'Sem Tema',
          }));
          list.sort((a, b) => b.week.localeCompare(a.week));
          setWeeklyList(list);
        }
      } catch (error) {
        console.error('Error fetching weeklies', error);
      } finally {
        setLoading(false);
      }
    };
    loadWeeklies();
  }, []);

  return (
    <DashboardLayout title="Semanários Salvos">
      {loading ? (
        <div className="alert alert-info border-0 shadow-sm">
          <div className="d-flex align-items-center">
            <span className="spinner-border spinner-border-sm text-primary me-3" role="status" aria-hidden="true"></span>
            Buscando semanários...
          </div>
        </div>
      ) : weeklyList.length === 0 ? (
        <div className="alert alert-info">
          Nenhum semanário encontrado.{' '}
          <Link to="/dashboard/weekly/add" className="alert-link">
            Adicione o primeiro
          </Link>.
        </div>
      ) : (
        <div className="list-group border-0">
          {weeklyList.map((item) => (
            <Link
              to={`/dashboard/weekly/edit/${item.week}`}
              className="list-group-item list-group-item-action d-flex flex-column flex-md-row justify-content-between align-items-md-center p-3 mb-3 shadow-sm border rounded"
              key={item.week}
            >
              <div>
                <h5 className="mb-1 fw-bold text-primary">
                  Semana {item.week.split('-W')[1]} ({item.week.split('-W')[0]})
                </h5>
                <h6 className="mb-2 text-muted">
                  <i className="bi bi-calendar-range"></i> {item.dates.start} até {item.dates.end}
                </h6>
                <p className="mb-0 text-dark">
                  <strong>Tema:</strong> {item.theme}
                </p>
              </div>
              <div className="mt-3 mt-md-0">
                <span className="btn btn-outline-primary btn-sm px-4 rounded-pill">
                  Visualizar / Editar
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
};

export default WeeklyList;
